import { render, staticRenderFns } from "./SidebarSubmenuItem.vue?vue&type=template&id=646198de"
import script from "./SidebarSubmenuItem.vue?vue&type=script&lang=js"
export * from "./SidebarSubmenuItem.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports